export const isAdminRole = (roleId: number): boolean =>
  roleId === -1 || roleId === -3 || roleId === 0;

export const isTherapistRole = (roleId: number): boolean => roleId >= 2;

export const isStaffRole = (roleId: number): boolean =>
  isAdminRole(roleId) || isTherapistRole(roleId);

export const STAFF_ROLE_IDS = [-1, -3, 0, 2, 3, 4, 5, 6, 7];
